/** @format */

import React, { useMemo, useState, forwardRef, useImperativeHandle } from "react";

import { Card } from "primereact/card";
import { Paginator } from "primereact/paginator";
import { RadioButton } from "primereact/radiobutton";
import { SURVEY } from "./constants/constants";
import { useParams } from "react-router-dom";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import useGetIndividualSurveyReport from "./hooks/useGetIndividualSurveyReport";

const getCurrentUserAnswer = (currentAns, surveyResponseDTO) => {
  if (currentAns === null || currentAns === undefined || surveyResponseDTO === null || surveyResponseDTO === undefined)
    return null;
  return {
    user: currentAns[0],
    userAnswer: surveyResponseDTO.questionRequestDTOS.map((ques) => {
      let answers = currentAns[1];
      let answer = answers.find((answ) => answ.questionId === ques.questionId);
      return {
        ...ques,
        ...answer,
      };
    }),
  };
};
const SurveyIndividual = forwardRef((props, ref) => {
  const params = useParams();
  const { data, isLoading } = useGetIndividualSurveyReport(
    params.id,
    params.id !== "" || params.id !== null || params.id !== undefined,
    props.status
  );
  let [page, setPage] = useState({
    first: 0,
    rows: 1,
  });
  const onPageChange = (event) => {
    setPage({
      first: event.first,
      rows: event.rows,
    });
  };

  let answerEnteries = useMemo(() => (data && data.userAnswers ? Object.entries(data.userAnswers) : []), [data]);
  let answeredCount = useMemo(() => answerEnteries.length, [answerEnteries]);
  let currentAns = answerEnteries[page.first];
  let surveyResponseDTO = useMemo(() => data && data.surveyResponseDTO, [data]);
  let currentUserAnswer = useMemo(
    () => getCurrentUserAnswer(currentAns, surveyResponseDTO),
    [currentAns, surveyResponseDTO]
  );
  useImperativeHandle(ref, () => {
    return {
      reportType: SURVEY.TYPE.INDIVIDUAL,
      getCurrentUserData: () => {
        let dataForExcel = currentUserAnswer
          ? currentUserAnswer.userAnswer.map((ans) => {
              let answerText = "-";
              if (ans.type === SURVEY.QUESTION__TYPES.SHORT_ANSWER) {
                answerText = ans.answerText;
              } else {
                const answerOption = ans.optionRequestDTOS.find((op) => op.optionId === ans.optionId);
                answerText = answerOption ? answerOption.option : answerText;
              }
              return {
                question: ans.name,
                answer: answerText,
                user: currentUserAnswer.user,
              };
            })
          : [];
        return dataForExcel;
      },
    };
  }, [currentUserAnswer]);
  return (
    <div className='survey__report__consolidated survey__report__individual' ref={ref}>
      {isLoading ? (
        <div className='wtg__loader'>
          <ThreeDotsLoader />
        </div>
      ) : null}
      {currentUserAnswer ? (
        <>
          <div className='flex align-items-baseline justify-content-between'>
            <p className='flex-1 print-hidden'>
              <b>Response {page.first + 1}</b>
            </p>
            <Paginator
              className='flex-1 print-hidden'
              first={page.first}
              rows={page.rows}
              totalRecords={answeredCount}
              onPageChange={onPageChange}
              template='CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown'
              currentPageReportTemplate='Showing {first} to {last} of {totalRecords}'
            ></Paginator>
            <p className='flex-1 text-right'>
              <span>Submitted By: {currentUserAnswer?.user}</span>
            </p>
          </div>
          {currentUserAnswer.userAnswer.map((ques, index) => {
            return (
              <Card key={ques.questionId} className='survey__report__individual__question__card p-6 mt-6'>
                <p className='survey__report__individual__question'>
                  {index + 1}. {ques.name}
                </p>
                <ul className='p-0'>
                  {ques.type === SURVEY.QUESTION__TYPES.MULTIPLE__CHOICE ? (
                    ques.optionRequestDTOS.map((answer, index) => {
                      return (
                        <li className='p-0 mt-2 mr-3' key={answer.optionId}>
                          <RadioButton value='' name='' checked={answer.optionId === ques.optionId} className='mr-3' />
                          {answer.optionId === ques.optionId ? <b>{answer.option}</b> : answer.option}
                        </li>
                      );
                    })
                  ) : (
                    <li className='my-2 mr-3'>
                      <Card>{ques.answerText}</Card>
                    </li>
                  )}
                </ul>
              </Card>
            );
          })}
        </>
      ) : (
        <p className='text-center'>No Responses</p>
      )}
    </div>
  );
});

export default SurveyIndividual;
